/* Product page: Order Ship Date Estimator (snippets/pdp-ship-date.liquid) + the Request a Quote form's
   event-date line, 2026-10-21. Date math: assets/lead-time.js (the Lead Time Calculator's engine).
   Ground shipping days come from the UPS rate worker (transit: true) for the ZIP, else the 5-day allowance.
   Plain ES5 like the rest of the theme. */
(function () {
  'use strict';
  var L = window.IDPSLeadTime;
  var root = document.getElementById('psd');
  if (!L || !root) return;

  var UPS_URL = 'https://ups-rate-proxy.idproductsource.workers.dev/rate';
  var ZIP_KEY = 'idps_ship_zip';
  var AIR = L.METHODS['2day'];

  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function today() { var n = new Date(); return L.day(n.getFullYear(), n.getMonth() + 1, n.getDate()); }
  function sameYear(d) { return d.getFullYear() === today().getFullYear(); }
  function fd(d) { return L.fmt(d, !sameYear(d)); }
  function fr(a, b) { return L.fmtRange(a, b, !sameYear(b)); }
  function md(d) { return L.MON[d.getMonth()] + ' ' + d.getDate(); }
  function mr(a, b) { return L.key(a) === L.key(b) ? md(a) : md(a) + ' – ' + md(b); }
  function days(r) { return r.lo === r.hi ? r.lo + '' : r.lo + '–' + r.hi; }

  var P = {
    range: L.parseRange(root.getAttribute('data-lead')),
    ships: root.getAttribute('data-ships') || '',
    origin: root.getAttribute('data-origin') || '',
    item: root.getAttribute('data-item') || ''
  };
  P.cal = L.prodCountry(P.origin, P.ships);
  P.oz = L.originKey(root.getAttribute('data-pid'), P.ships);   // the rate worker looks the origin up from the product id
  P.ob = L.originBody(root.getAttribute('data-pid'), P.ships);
  P.direct = L.shipsDirect(P.ships);

  /* ── UPS Ground days for a ZIP (shared by the estimator and the quote form) ── */
  var transitCache = {}, pending = {}, listeners = [];
  function groundDays(zip) {
    if (!/^\d{5}$/.test(zip || '')) return { days: L.GROUND_ALLOWANCE, src: 'nozip' };
    var k = P.oz + '>' + zip;
    if (typeof transitCache[k] === 'number') return { days: transitCache[k], src: 'ups' };
    if (transitCache[k] === null) return { days: L.GROUND_ALLOWANCE, src: 'fail' };
    if (!pending[k]) {
      pending[k] = 1;
      fetch(UPS_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: P.ob.productId, shipsFrom: P.ob.shipsFrom, destZip: zip, weightLbs: 2, transit: true, services: ['03'] })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        var n = null, rates = (j && j.rates) || [];
        for (var i = 0; i < rates.length; i++) if (rates[i].code === '03' && rates[i].businessDays) n = parseInt(rates[i].businessDays, 10);
        transitCache[k] = n > 0 && n < 15 ? n : null;
      }).catch(function () { transitCache[k] = null; }).then(function () {
        delete pending[k];
        listeners.forEach(function (f) { f(); });
      });
    }
    return { days: L.GROUND_ALLOWANCE, src: 'wait' };
  }
  function planWith(order, o) {
    o = o || {};
    return L.plan({
      order: order, lo: P.range.lo, hi: P.range.hi, cal: P.cal,
      changesLo: o.changes ? 1 : 0, changesHi: o.changes ? 2 : 0, transit: o.transit
    });
  }
  /* the cheapest faster UPS service that makes the date, as a sentence */
  function fasterFix(order, ev, changes, slowerThan) {
    var list = ['2day', '1day'];
    for (var i = 0; i < list.length; i++) {
      var M = L.METHODS[list[i]];
      if (slowerThan != null && M.days >= slowerThan) continue;
      var p = planWith(order, { changes: changes, transit: M.days });
      if (p.handHi <= ev) return M.name + ' gets it there by ' + fd(p.handHi) + '.';
    }
    return '';
  }

  /* ── the estimator ── */
  var els = {
    order: $('psd-order'), event: $('psd-event'), zip: $('psd-zip'), todayTag: $('psd-today'),
    none: $('psd-none'), out: $('psd-out'), ships: $('psd-ships'), shipsSub: $('psd-ships-sub'),
    hand: $('psd-hand'), handSub: $('psd-hand-sub'), verdict: $('psd-verdict'), steps: $('psd-steps'),
    closed: $('psd-closed'), wiCh: $('psd-wi-changes'), wiChT: $('psd-wi-changes-t'), wiAir: $('psd-wi-air'),
    wiAirT: $('psd-wi-air-t'), note: $('psd-note'), link: $('psd-link')
  };
  var S = { changes: false, air: false };
  var ICON = {
    ok: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M7.5 12.5l3 3 6-6.5"></path></svg>',
    warn: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4M12 17h.01"></path><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"></path></svg>'
  };
  function orderDate() { return L.parseDate(els.order.value) || today(); }
  function zipVal() { return els.zip.value.trim(); }

  function render() {
    els.todayTag.hidden = L.key(orderDate()) !== L.key(today());
    if (!P.range) { els.none.hidden = false; els.out.hidden = true; return; }
    els.none.hidden = true;
    els.out.hidden = false;
    var order = orderDate();
    var ev = L.parseDate(els.event.value);
    var zip = zipVal();
    var zipOk = /^\d{5}$/.test(zip);
    if (!zipOk) S.air = false;
    /* No ZIP = no transit time and no in-hand date (Brett, 2026-10-21): the in-hand date waits for UPS. */
    var g = zipOk ? groundDays(zip) : { days: 0, src: 'nozip' };
    var known = zipOk && (S.air || g.src === 'ups' || g.src === 'fail');
    var hand = !zipOk ? 'nozip' : known ? 'known' : 'wait';
    var tr = S.air ? AIR.days : g.days;
    var p = planWith(order, { changes: S.changes, transit: tr });

    els.ships.textContent = fr(p.shipLo, p.shipHi);
    els.shipsSub.textContent = days(P.range) + ' business days after proof approval' + (S.changes ? ', plus 1–2 days for changes' : '');
    els.zip.classList.toggle('psd__need', hand === 'nozip');
    els.hand.classList.toggle('psd__big--muted', hand !== 'known');
    if (hand === 'nozip') {
      els.hand.textContent = 'Add your ZIP';
      els.handSub.textContent = 'We’ll ask UPS how long it takes to get there.';
    } else if (hand === 'wait') {
      els.hand.textContent = 'Checking UPS…';
      els.handSub.textContent = 'UPS Ground to ' + zip;
    } else {
      els.hand.textContent = fr(p.handLo, p.handHi);
      /* over a weekend: "· ships Fri, no weekend delivery" (lead-time.js weekendTag) */
      if (S.air) els.handSub.textContent = AIR.name + ' to ' + zip + ', 2 business days' + (L.weekendTag ? L.weekendTag(p) : '');
      else if (g.src === 'ups') els.handSub.textContent = 'UPS Ground to ' + zip + ', ' + L.plural(g.days, 'business day') + (L.weekendTag ? L.weekendTag(p) : '');
      else els.handSub.textContent = 'UPS didn’t answer, so this plans on up to ' + L.GROUND_ALLOWANCE + ' business days of UPS Ground';
    }

    /* verdict */
    var approve = 'Approve the proof by ' + fd(p.approve) + '.';
    var v = ev && known ? L.verdict(p, ev) : null;
    var cls, html;
    if (!v) {
      cls = 'psd__vd--none';
      if (hand === 'nozip') html = ev
        ? '<div><b>Add your ship-to ZIP to check ' + esc(fd(ev)) + '</b><span>We need it for the UPS transit days.</span></div>'
        : '<div><b>Add your ZIP and in-hands date</b><span>We’ll show when it arrives, whether it makes your date and the last day to order.</span></div>';
      else if (hand === 'wait') html = '<div><b>Checking UPS for ' + esc(zip) + '…</b></div>';
      else html = '<div><b>Add your in-hands date</b><span>We’ll tell you if it makes it and the last day to order.</span></div>';
    } else if (v.kind === 'ok') {
      cls = 'psd__vd--ok';
      html = ICON.ok + '<div><b>Makes ' + esc(fd(ev)) + '</b><span>' + esc(v.spare ? L.plural(v.spare, 'business day') + ' to spare, even on the slow end. ' : 'No spare day on the slow end. ') + esc(approve) + '</span></div>';
    } else {
      var ob = L.orderBy(ev, { hi: P.range.hi, cal: P.cal, changesHi: S.changes ? 2 : 0, transit: tr });
      var fix = S.air ? fasterFix(order, ev, S.changes, AIR.days) : fasterFix(order, ev, S.changes);
      var obTxt = ob ? (ob >= order ? 'To be safe, order by ' + fd(ob) + '. ' : 'To make it, it needed ordering by ' + fd(ob) + '. ') : '';
      if (v.kind === 'maybe') {
        cls = 'psd__vd--maybe';
        var sure = ob ? (ob >= order ? 'To be safe, order by ' + fd(ob) + '. ' : 'To be sure, it needed ordering by ' + fd(ob) + '. ') : '';
        html = ICON.warn + '<div><b>Might make ' + esc(fd(ev)) + '</b><span>Only if production takes the short end. ' + esc(sure) + esc(fix) + '</span></div>';
      } else {
        cls = 'psd__vd--late';
        html = ICON.warn + '<div><b>Misses ' + esc(fd(ev)) + ' by ' + esc(v.over === v.overHi ? L.plural(v.over, 'business day') : v.over + '–' + v.overHi + ' business days') + '</b><span>' +
          esc(obTxt) + esc(fix ? fix + ' ' : '') + 'Ask us about rush with Request a Quote.</span></div>';
      }
    }
    els.verdict.className = 'psd__vd ' + cls;
    els.verdict.innerHTML = html;

    /* step by step */
    var startTxt = L.key(p.startLo) === L.key(p.shipHi) ? md(p.startLo) : mr(p.startLo, p.shipHi);
    var stops = [
      ['Order', md(order) + (L.key(p.received) !== L.key(order) ? ', starts ' + md(p.received) : ''), ''],
      ['Proof', md(p.proof), S.changes ? 'approved by ' + md(p.apprHi) : 'approve same day'],
      ['Production', startTxt, days(P.range) + ' business days'],
      ['Ships', mr(p.shipLo, p.shipHi), ''],
      ['In hand', hand === 'known' ? mr(p.handLo, p.handHi) : hand === 'wait' ? 'Checking UPS…' : 'Add your ZIP', '']
    ];
    els.steps.classList.toggle('psd__steps--nohand', hand !== 'known');
    els.steps.innerHTML = stops.map(function (s, i) {
      var c = i === 4 ? (hand === 'known' ? ' psd__stop--hand' : ' psd__stop--wait') : '';
      return '<li class="psd__stop' + c + '"><span class="psd__dot" aria-hidden="true"></span> <b>' + esc(s[0]) + '</b> <span>' + esc(s[1]) + '</span>' +
        (s[2] ? ' <small>' + esc(s[2]) + '</small>' : '') + '</li>';
    }).join('');
    var closed = p.closed.map(function (c) {
      return md(c.date) + ' ' + c.name + (c.cal === 'CN' ? ' (overseas factory)' : c.cal === 'MX' ? ' (factory in Mexico)' : '');
    });
    els.closed.hidden = !closed.length;
    els.closed.textContent = closed.length ? 'Closed days counted: ' + closed.join(' · ') + '.' : '';

    /* what-ifs: each shows its effect from the current settings */
    var withCh = planWith(order, { changes: true, transit: tr });
    els.wiChT.innerHTML = known ? 'In hand as late as ' + esc(fd(withCh.handHi)) + short(withCh, ev) : 'Ships as late as ' + esc(fd(withCh.shipHi));
    if (zipOk) {
      var withAir = planWith(order, { changes: S.changes, transit: AIR.days });
      els.wiAirT.innerHTML = 'In hand ' + esc(fr(withAir.handLo, withAir.handHi)) + short(withAir, ev);
    } else {
      els.wiAirT.textContent = 'Add your ZIP to compare';
    }
    els.wiAir.disabled = !zipOk;
    els.wiCh.setAttribute('aria-pressed', S.changes ? 'true' : 'false');
    els.wiAir.setAttribute('aria-pressed', S.air ? 'true' : 'false');
    els.note.hidden = !P.direct;

    /* the full plan in the Lead Time Calculator */
    if (P.item) {
      var q = '?sku=' + encodeURIComponent(P.item);
      if (L.key(order) !== L.key(today())) q += '&from=' + L.key(order);
      if (ev) q += '&date=' + L.key(ev);
      if (/^\d{5}$/.test(zipVal())) q += '&zip=' + zipVal();
      if (S.air) q += '&ship=2day';
      els.link.setAttribute('href', '/pages/lead-time-calculator' + q);
    }
  }
  function short(p, ev) {
    if (!ev) return '';
    var v = L.verdict(p, ev);
    if (v.kind === 'ok') return ' · <em class="psd__ok">' + (v.spare ? L.plural(v.spare, 'day') + ' to spare' : 'makes it') + '</em>';
    if (v.kind === 'maybe') return ' · <em class="psd__mb">could miss ' + esc(md(ev)) + '</em>';
    return ' · <em class="psd__late">misses ' + esc(md(ev)) + '</em>';
  }

  /* ZIP: always empty when the page loads (Brett, 2026-10-21: nothing remembered between pages); shared with
     the Shipping Cost Estimator's empty ZIP box while on the page. The key the first version saved is cleared. */
  function shareZip(z) {
    var other = $('ship-zip');
    if (other && !other.value) other.value = z;
  }
  els.order.value = L.key(today());
  els.zip.value = '';
  try { localStorage.removeItem(ZIP_KEY); } catch (e) {}
  [els.order, els.event].forEach(function (el) { el.addEventListener('change', render); el.addEventListener('input', render); });
  els.zip.addEventListener('input', function () {
    var v = els.zip.value.replace(/\D/g, '').slice(0, 5);
    if (v !== els.zip.value) els.zip.value = v;
    if (v.length === 5) shareZip(v);
    render();
  });
  var otherZip = $('ship-zip');
  if (otherZip) otherZip.addEventListener('change', function () {
    var v = otherZip.value.trim();
    if (/^\d{5}$/.test(v) && !els.zip.value) { els.zip.value = v; render(); }
  });
  els.wiCh.addEventListener('click', function () { S.changes = !S.changes; render(); });
  els.wiAir.addEventListener('click', function () { S.air = !S.air; render(); });
  listeners.push(render);
  render();
  /* Chrome puts a typed value back into a form-less date box after Back without an input event
     (the same trap as #ship-qty, ticket #1167): re-read on pageshow and on the next tick. */
  window.addEventListener('pageshow', render);
  setTimeout(render, 0);

  /* ── Request a Quote: the line under Event Date ── */
  (function quoteHint() {
    var input = $('q-event-date');
    var hint = $('q-date-hint');
    if (!input || !hint) return;
    var zipEl = $('q-delivery-zip');
    function qzip() { var z = zipEl ? zipEl.value.trim() : ''; return /^\d{5}$/.test(z) ? z : (/^\d{5}$/.test(zipVal()) ? zipVal() : ''); }
    function set(text, kind) {
      hint.textContent = text;
      hint.classList.remove('pdp-form__hint--warn', 'pdp-form__hint--ok');
      if (kind) hint.classList.add('pdp-form__hint--' + kind);
    }
    function update() {
      if (!P.range) { set('Optional: add your in-hands date and our team will confirm timing.', ''); return; }
      var order = today();
      var z = qzip();
      var ev = L.parseDate(input.value);
      var ship = planWith(order, { transit: 0 });
      var shipTxt = 'Ships ' + fr(ship.shipLo, ship.shipHi) + ' if ordered today.';
      /* no ZIP = no in-hand date: the check waits for the delivery ZIP (same rule as the estimator) */
      if (!z) { set(shipTxt + (ev ? ' Add the delivery ZIP below to check ' + fd(ev) + '.' : ' Add your date and delivery ZIP and we’ll check it.'), ''); return; }
      var g = groundDays(z);
      if (g.src === 'wait') { set(shipTxt + ' Checking UPS for ' + z + '…', ''); return; }
      var p = planWith(order, { transit: g.days });
      var to = g.src === 'ups' ? ' by UPS Ground to ' + z : ' by UPS Ground (planning on up to ' + L.GROUND_ALLOWANCE + ' business days)';
      if (!ev) { set(shipTxt + ' In hand ' + fr(p.handLo, p.handHi) + to + '. Add your date and we’ll check it.', ''); return; }
      var v = L.verdict(p, ev);
      if (v.kind === 'ok') { set('Works. Ships ' + fr(p.shipLo, p.shipHi) + ' and arrives by ' + fd(p.handHi) + to + '. We’ll confirm with your quote.', 'ok'); return; }
      var fix = fasterFix(order, ev, false);
      if (v.kind === 'maybe') {
        set('Tight. UPS Ground could arrive ' + fd(p.handHi) + '. ' + (fix ? fix + ' ' : '') + 'Send the request and we’ll confirm the fastest way.', 'warn');
        return;
      }
      set('Sooner than standard production allows: the earliest by UPS Ground is ' + fr(p.handLo, p.handHi) + '. ' + (fix ? fix + ' ' : '') +
        'Send the request and we’ll check rush options.', 'warn');
    }
    input.addEventListener('change', update);
    input.addEventListener('input', update);
    if (zipEl) zipEl.addEventListener('input', update);
    els.zip.addEventListener('input', update);
    listeners.push(update);
    update();
  })();
})();
